function throttle(func, ms) {
  let lastTime = 0;
  return function (...args) {
    const now = Date.now();
    if (now - lastTime >= ms) {
      func(...args);
      lastTime = now;
    }
  };
}
export default throttle;